<template>
<div class="polygon-container">
    <svg>
      <g>
        <circle
            v-for="(point, index) in points"
            :key="index"
            :cx="point.x"
            :cy="point.y"
            @click="setFinished"
            r="4" />
      </g>
      <polyline
          v-if="!isDrawingFinished"
          :points="pointCoords"
          class="preview"
      />
      <component
          :is="figureType"
          :points="pointCoords"
          :class="isDrawingFinished ? 'finished' : 'unfinished'"
      />
    </svg>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState('polygon', ['points', 'isDrawingFinished']),

        /**
         * Indicates whether we draw a polyline or polygon
         */
        figureType() {
            return this.points.length < 3 ? 'polyline' : 'polygon';
        },

        /**
         * Converts points to format used by svg polygon
         */
        pointCoords() {
            return this.points.map(({ x, y }) => `${x}, ${y}`).join(' ');
        },
    },

    methods: {
        ...mapActions('polygon', ['setFinished']),
    },
};
</script>
